(function ($) {
    'use strict';
    /**
      * плагин масштабирвоания текста
     * */
    $.fn.textScaler = function () {
        var $self = $(this);
        var $text = $self.find('.js-scaler-text');
        var selfWidth = parseInt($self.css('width'));
        var textWidth = $text.width();
        var fontSizeText = parseInt($text.css('font-size'));
        var factor = 1;
        var coefficient = $self.data('coefficient') ? $self.data('coefficient') : 0.8;

        /**
         * подсчет разницы ширины контейнера и текста
         * */
        var calcFactor = function () {
            factor = selfWidth / textWidth;
        };
        /**
         * инициализация плагина
         * */
        var init = function () {
            if(textWidth > selfWidth) {
                calcFactor();
                $text.css({fontSize: (fontSizeText * factor * coefficient) + 'px'});
            };
        };
        init();
        return this;
    };
    $('.js-scaler').each(function () {
        $(this).data('textScaler', $(this).textScaler());
    });
})(jQuery);
